export enum CHART_STATUSES {
  DRAFT = 'draft',
  GENERATING = 'generating',
  PENDING = 'pending',
  ACTIVE = 'active',
  ERRORED = 'errored',
}

export default CHART_STATUSES;

